export default {
  methods: {
    //TODO improve this method
    cloneArray(arr) {
      var i, copy;

      if (Array.isArray(arr)) {
        copy = arr.slice();
        for (i = 0; i < copy.length; i++) {
          copy[i] = this.cloneArray(copy[i]);
        }
        return copy;
      } else if (typeof arr === 'object' && 'isActiveClone' in arr) {
        var temp = undefined;

        if (arr instanceof Date) {
          temp = new arr.constructor(); //or new Date(obj);
        } else {
          temp = arr.constructor();
        }

        for (var key in arr) {
          if (Object.prototype.hasOwnProperty.call(arr, key)) {
            arr['isActiveClone'] = null;
            temp[key] = this.cloneArray(arr[key]);
            delete arr['isActiveClone'];
          }
        }

        return temp;
      } else {
        return arr;
      }
    },

    getQueryParameterByName(name, defaultParameter, url) {
      if (!url) url = location.href;

      name = name.replace(/[\[\]]/g, "\\$&");

      let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);

      if (!results) return defaultParameter ? defaultParameter : null;

      if (!results[2]) return defaultParameter ? defaultParameter : '';

      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },

    throttle(callback, limit) {
      let wait = false;

      return () => {
        if (wait) return;

        wait = true;

        setTimeout(() => {
          callback.call();

          wait = false;
        }, limit);
      };
    },

    getFullName(item) {
      return `${item.first_name} ${item.last_name}`;
    },

    getDate(dateString) {
      return moment(dateString).format('YYYY-MM-DD');
    }
  }
};
